import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import categoriesAdapter from './categories.adapter';
import { Category, CategoryGroup, CategoryState } from './types';

const initialState: CategoryState = {
  ids: [],
  entities: {},
  groups: [],
};

export const { reducer, actions } = createSlice({
  name: 'categories',
  initialState,
  reducers: {
    getCategoriesSuccess: (state, action: PayloadAction<{ groups: CategoryGroup[]; categories: Category[] }>) => {
      categoriesAdapter.setAll(state, action.payload.categories);
      state.groups = action.payload.groups;
    },
    getCategoriesFailed: state => {
      categoriesAdapter.setAll(state, []);
      state.groups = [];
    },
  },
  extraReducers: {},
});
